import styled from 'styled-components'

import { media } from 'src/styles/media'

export const NavWrap = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 8.8rem;
  padding: 0 3.2rem;

  ${media.desktop} {
    box-shadow: inset 0 -0.1rem 0 0 #eeebeb;
  }
`

export const LogoWrap = styled.div`
  position: absolute;
  left: 3.2rem;
  display: none;

  ${media.desktop} {
    display: flex;
  }
`

export const LinksWrap = styled.div`
  position: absolute;
  left: 3.2rem;
  display: flex;

  ${media.desktop} {
    right: 3.2rem;
    left: unset;

    svg {
      margin-left: 0.8rem;
    }
  }
`
